module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_tvb-e045d74a58b53c61592ee58d63899236.svg";